module.exports = __webpack_public_path__ + "static/img/banner-dynamic.b8be95b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner-dynamic.png
// module id = MlUy
// module chunks = 1